import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { FacadeSesionService } from 'src/app/services/facade-sesion.service';
import { FacadeUsuarioService } from 'src/app/services/facade-usuario.service';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';
import { Observable } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { Rol } from 'src/app/models/entities/rol';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormUtils } from 'src/app/shared/utils/form-utils';
import { UsuarioService } from 'src/app/services/usuario.service';
import { AlertasService } from 'src/app/services/alertas.service';
import { UsuarioRolService } from 'src/app/services/usuario-rol.service';
import { UsuarioRol } from 'src/app/models/entities/usuario-rol';

@Component({
  selector: 'administrar-usuarios',
  templateUrl: './administrar-usuarios.component.html',
  styleUrls: ['./administrar-usuarios.component.scss']
})
export class AdministrarUsuariosComponent implements OnInit {

  @ViewChild('modalEdicionUsuario')
  public modalEdicionUsuario: any;
  public modalActivoEdicionUsuario: NgbModalRef;
  public clonedUsers: { [s: string]: any; } = {};
  public usuarios$: Observable<UsuarioSesionDTO[]> = null;
  public catRoles$: Observable<Rol[]> = null;
  public usuarios: UsuarioSesionDTO[] = [];
  public catalogoRoles: Rol[] = [];
  public usuarioEdicionSeleccionado: UsuarioSesionDTO;
  public usuarioRolKey: any;
  public edicionUsuarioForm: FormGroup;
  public anioActual: number = new Date().getFullYear();
  public idiomaCalendario: any;
  public readonly fechaActual: number = new Date().getTime();
  public usuarioEnSesion: UsuarioSesionDTO = null;

  constructor(
    private ngbModalService: NgbModal,
    private formBuilder: FormBuilder,
    private facadeSesionService: FacadeSesionService,
    private facadeUsuarioService: FacadeUsuarioService,
    public dateUtils: DateUtils,
    public formUtils: FormUtils,
    public catalogoService: CatalogoService,
    private usuarioService: UsuarioService,
    private alertasService: AlertasService,
    private usuarioRolService: UsuarioRolService
  ) { }

  ngOnInit() {
    this.facadeSesionService.breadcrumbService.actualizarBreadcrumbFuncionalidad('Gestión de perfiles');
    this.facadeSesionService.usuarioEnSesionService.obtenerUsuario().subscribe(
      (usuarioEnSesion: UsuarioSesionDTO) => this.usuarioEnSesion = usuarioEnSesion
    )
    this.usuarios$ = this.facadeUsuarioService.obtenerUsuariosConSuRol().pipe(take(1));
    this.usuarios$.subscribe(usuarios => this.usuarios = usuarios);
    this.catRoles$ = this.catalogoService.obtenerCatalogo<Rol>(RutaCatalogoEnum.ROLES).pipe(take(1));
    this.catRoles$.subscribe(catalogos => this.catalogoRoles = catalogos);
    this.idiomaCalendario = this.dateUtils.idiomaEspanol;
  }

  public abrirModalEdicionUsuario(usuario: UsuarioSesionDTO) {
    this.usuarioRolKey = usuario.rol.key;
    this.usuarioEdicionSeleccionado = usuario;
    this.edicionUsuarioForm = this.formBuilder.group({
      habilitado: new FormControl(usuario.usuario.estatus, [Validators.required]),
      rol: new FormControl(usuario.rol.key, [Validators.required]),
      nombre: new FormControl(usuario.usuario.nombre, [Validators.required]),
      primerApellido: new FormControl(usuario.usuario.primerApellido, [Validators.required]),
      segundoApellido: new FormControl(usuario.usuario.segundoApellido),
      telefono: new FormControl(usuario.usuario.telefono),
      fechaNacimiento: new FormControl(new Date(usuario.usuario.fechaNacimiento), [Validators.required])
    });
    this.modalActivoEdicionUsuario = this.ngbModalService.open(this.modalEdicionUsuario, { centered: true, windowClass: 'modal-confirmacion' });
  }

  public actualizarUsuario() {
    let rolActual = this.edicionUsuarioForm.value.rol;
    let infoRolSeleccionado = this.catalogoRoles.find(rol => rol.key == rolActual);
    this.usuarioEdicionSeleccionado.usuario.estatus = this.edicionUsuarioForm.value.habilitado;
    this.usuarioEdicionSeleccionado.usuario.nombre = this.edicionUsuarioForm.value.nombre.toUpperCase();
    this.usuarioEdicionSeleccionado.usuario.primerApellido = this.edicionUsuarioForm.value.primerApellido.toUpperCase();
    this.usuarioEdicionSeleccionado.usuario.segundoApellido = this.edicionUsuarioForm.value.segundoApellido.toUpperCase();
    this.usuarioEdicionSeleccionado.usuario.telefono = this.edicionUsuarioForm.value.telefono;
    this.usuarioEdicionSeleccionado.usuario.fechaNacimiento = (this.edicionUsuarioForm.value.fechaNacimiento as Date).getTime();
    this.usuarioEdicionSeleccionado.usuario.fechaActualizacion = this.fechaActual;
    let usuarioActualizado = { ...this.usuarioEdicionSeleccionado.usuario };
    delete usuarioActualizado.key;
    this.usuarioService.updateUsuario(this.usuarioEdicionSeleccionado.usuario.key, usuarioActualizado).then(
      () => {
        this.alertasService.mostrarAlerta('success', 'Usuario actualizado.');
        this.cerraModalEdicionUsuario();
        if (this.usuarioEnSesion.usuario.key === this.usuarioEdicionSeleccionado.usuario.key) {
          this.facadeSesionService.usuarioEnSesionService.actualizarUsuario({ ...this.usuarioEdicionSeleccionado });
        }
      }
    )
    if (this.usuarioRolKey !== this.edicionUsuarioForm.value.rol) {
      this.usuarioEdicionSeleccionado.rol.key = this.edicionUsuarioForm.value.rol;
      this.usuarioEdicionSeleccionado.rol.fechaActualizacion = this.fechaActual;
      this.usuarioEdicionSeleccionado.rol.nombre = infoRolSeleccionado.nombre;
      this.usuarioEdicionSeleccionado.rol.descripcion = infoRolSeleccionado.descripcion;
      this.usuarioRolService.deleteUsuario(this.usuarioEdicionSeleccionado.usuario.key, this.usuarioRolKey).then(
        () => {
          let usuarioRol: UsuarioRol = {
            keyUsuario: this.usuarioEdicionSeleccionado.usuario.key,
            keyRol: this.edicionUsuarioForm.value.rol,
            fechaActualizacion: this.fechaActual,
            fechaCreacion: this.fechaActual
          };
          this.usuarioRolService.save(usuarioRol).then(
            () => {
              this.cerraModalEdicionUsuario();
              if (this.usuarioEnSesion.usuario.key === this.usuarioEdicionSeleccionado.usuario.key) {
                this.facadeSesionService.usuarioEnSesionService.actualizarUsuario({ ...this.usuarioEdicionSeleccionado });
              }
            }
          )
        }
      );
    }
  }

  public cerraModalEdicionUsuario() {
    this.modalActivoEdicionUsuario.close();
  }

}
